import { IPromise } from 'angular';
import * as _ from 'underscore';

import { Filter } from '../helpers/Filter';
import { RequestHelper } from '../helpers/RequestHelper';
import { ResultHelper } from '../helpers/ResultHelper';
import { IScheduleInfo } from '../models/IScheduleInfo';
import { Module } from '../Module';
import {
  CreateScheduleRequest,
  ICreateScheduleParams,
  ICreateScheduleResult,
} from '../ServerApi/requests/CreateScheduleRequest';
import { DeleteSchedulesRequest } from '../ServerApi/requests/DeleteSchedulesRequest';
import { GetSchedulesRequest, IGetSchedulesResult } from '../ServerApi/requests/GetSchedulesRequest';
import { RunSchedulesRequest } from '../ServerApi/requests/RunSchedulesRequest';
import { RunServerSchedulesRequest } from '../ServerApi/requests/RunServerSchedulesRequest';
import { SetEnabledStatusForSchedulesRequest } from '../ServerApi/requests/SetEnabledStatusForSchedulesRequest';
import { SetScheduleNameRequest } from '../ServerApi/requests/SetScheduleNameRequest';
import { IUpdateScheduleParams, UpdateScheduleRequest } from '../ServerApi/requests/UpdateScheduleRequest';
import { FilterFieldNames, IValuedFieldFilterClause } from '../ServerApi/types/IFilterClause';
import { IResult } from '../ServerApi/types/IResponse';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { FetcherFactory } from '../services/FetcherFactory';
import { Resource } from './Resource';

export class Schedules extends Resource<IScheduleInfo> {

  public static filterByActionType(scheduledActionType: string): IValuedFieldFilterClause<string> { // ScheduleActions
    return Filter.fieldEq(FilterFieldNames.scheduledAction, scheduledActionType);
  }

  public static $inject = ['ErrorNotifyingServer', 'FetcherFactory'];

  constructor(private ErrorNotifyingServer: ErrorNotifyingServer, FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetSchedulesRequest,
      (result: IGetSchedulesResult) => {
        return result.schedules.map((schedule) => {
          return {
            ...schedule,
            contentType: 'schedule'
          };
        });
      }
    ));
  }

  public getByIdForSite(id: string, siteId?: string) {
    return this.getById(id, _(siteId).isString() ? [ Filter.fieldEq(FilterFieldNames.siteId, siteId) ] : []);
  }

  private setEnabledStatus(ids: string[], status: boolean): IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetEnabledStatusForSchedulesRequest(idsBlock, status)),
      ResultHelper.combineResults);
  }

  public disable(ids: string[]): IPromise<IResult> {
    return this.setEnabledStatus(ids, false);
  }

  public enable(ids: string[]): IPromise<IResult> {
    return this.setEnabledStatus(ids, true);
  }

  public del(ids: string[]): IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteSchedulesRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public runServer(ids: string[]): IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new RunServerSchedulesRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public run(ids: string[]): IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new RunSchedulesRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public create(schedule: ICreateScheduleParams): IPromise<ICreateScheduleResult> {
    return this.ErrorNotifyingServer.sendRequest(new CreateScheduleRequest(schedule));
  }

  public update(schedule: IUpdateScheduleParams): IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequest(new UpdateScheduleRequest(schedule));
  }

  public rename(id: string, newName: string): IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequest(new SetScheduleNameRequest(id, newName));
  }

}

Module.instance().service('Schedules', Schedules);
